import { UPDATE_DOMAIN_CONFIGURATION } from "../constants";

const initialState = {
    config: null,
    loading: false,
    isLewooTrack: true,
    error: null,
};

export const setDomainConfiguration = (data) => ({
    type: UPDATE_DOMAIN_CONFIGURATION,
    data,
});

export const domainConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DOMAIN_CONFIGURATION:
            return {
                ...state, ...action.data, isLewooTrack: action.data.config?.header?.title === "Lewootrack"
            };
        default:
            return state;
    }
};
